import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'contextual-menu.drilldown-back-button-label': {
    id: 'contextual-menu.drilldown-back-button-label',
    defaultMessage: 'Back',
    description:
      'Accessible label for the back-arrow icon on the drilldown menu back button',
  },
});
